export default class PdfModal {


    constructor(el) {
        this.$el = el;
        this.init();
    }

    init() {
        this.events();

    }

    events() {

        jQuery('#pdf-modal').on('show.bs.modal', (e) => {
            e.target.querySelector('.download-file').setAttribute('href', e.relatedTarget.dataset.pdf);
            this.renderViwer(e.target, e.relatedTarget.dataset.pdf);
            setTimeout(function() {
                initPDFViewer(e.relatedTarget.dataset.pdf);
            }, 600);
        });


    }

    renderViwer(element, pdf) {

        let contentWrap = element.querySelector('.modal-body');
        //
        let pdfBook = `
					<div class="viewport-container">
						<div role="main" class="viewport"></div>
					</div>
					`;
        contentWrap.innerHTML = pdfBook;

        let pagination = element.querySelector('.pagination');
        let pager = `<div class="pager">
					<p class="prev-page"><button data-pager="prev"><i class="icon left-arrow" data-pager="prev"></i></button></p>
					<p class="pages"><span class="current"></span> - <span class="total"></span></p>
					<p class="next-page page-mode"><button data-pager="next"><i class="icon right-arrow" data-pager="next"></i></button></p>
				</div>`;
        pagination.innerHTML = pager;

        this.viwer(element);
        //initPDFViewer(pdf);




    }

    viwer(element) {
        (function() {
            let currentPageIndex = 0;
            let pageMode = 1;
            let cursorIndex = Math.floor(currentPageIndex / pageMode);
            let pdfInstance = null;
            let totalPagesCount = 0;

            const viewport = document.querySelector('.viewport');
            window.initPDFViewer = function(pdfURL) {
                pdfjsLib.getDocument(pdfURL).then(pdf => {
                    pdfInstance = pdf;
                    totalPagesCount = pdf.numPages;
                    initPager();
                    //initPageMode();
                    render();
                });

            };

            function onPagerButtonsClick(event) {
                const action = event.target.getAttribute("data-pager");
                if (action === "prev") {
                    if (currentPageIndex === 0) {
                        return;
                    }
                    currentPageIndex -= pageMode;
                    if (currentPageIndex < 0) {
                        currentPageIndex = 0;
                    }
                    render();
                }
                if (action === "next") {
                    if (currentPageIndex === totalPagesCount - 1) {
                        return;
                    }
                    currentPageIndex += pageMode;
                    if (currentPageIndex > totalPagesCount - 1) {
                        currentPageIndex = totalPagesCount - 1;
                    }
                    render();
                }
            }


            function initPager() {
                const pager = document.querySelector(".pager");
                pager.addEventListener("click", onPagerButtonsClick);
                return () => {
                    pager.addEventListener("click", onPagerButtonsClick);
                };
            }

            function onPageModeChange(event) {
                pageMode = 0;
                render();
            }

            function initPageMode() {
                const input = document.querySelector(".page-mode button");
                input.setAttribute("max", totalPagesCount);
                input.addEventListener("change", onPageModeChange);
                return () => {
                    input.removeEventListener("change", onPageModeChange);
                };
            }

            function render() {
                cursorIndex = Math.floor(currentPageIndex / pageMode);
                const startPageIndex = cursorIndex * pageMode;
                const endPageIndex =
                    startPageIndex + pageMode <= totalPagesCount ?
                    startPageIndex + pageMode - 1 :
                    -1;

                const renderPagesPromises = [];
                for (let i = startPageIndex; i <= endPageIndex; i++) {
                    renderPagesPromises.push(pdfInstance.getPage(i + 1));
                }

                Promise.all(renderPagesPromises).then(pages => {
                    const pagesHTML = `<div style="width: ${
						pageMode > 1 ? "50%" : "100%"
						}"><canvas></canvas></div>`.repeat(pages.length);
                    viewport.innerHTML = pagesHTML;
                    pages.forEach(renderPage);
                });

            }

            function renderPage(page) {
                let pdfViewport = page.getViewport(1);
                const container =
                    viewport.children[page.pageIndex - cursorIndex * pageMode];
                pdfViewport = page.getViewport(container.offsetWidth / pdfViewport.width);
                const canvas = container.children[0];
                const context = canvas.getContext("2d");
                canvas.height = pdfViewport.height;
                canvas.width = pdfViewport.width;

                page.render({
                    canvasContext: context,
                    viewport: pdfViewport
                });

                changePagination(currentPageIndex, totalPagesCount);
            }

            function changePagination(current, total) {


                let pager = element.querySelector('.pager');
                let currentCount = pager.querySelector('span.current');
                let totalCount = pager.querySelector('span.total');
                currentCount.innerHTML = current + 1;
                totalCount.innerHTML = total;
            }
        })();
    }

}